import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LayoutFullScreenOverlay from "@/ui/layouts/LayoutFullScreenOverlay";
import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";
import { ViewFileExtractionModal } from "@/ui/compositionRootUI";

export const FileExtractionModalOverlay: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { fileId, databaseId, projectId } = useParams() as {
        fileId: string;
        databaseId: string;
        projectId: string;
    };

    const handleOverlayClick = () => {
        const basePath = location.pathname.split("files")[0];
        if (typeof basePath === "string") {
            navigate(basePath, { replace: true });
        }
    };

    return (
        <LayoutFullScreenOverlay
            backgroundColor={"var(--proda-black)"}
            opacity={0.8}
            onClick={handleOverlayClick}
        >
            <LayoutFillParentCentered>
                <ViewFileExtractionModal
                    projectId={parseInt(projectId)}
                    databaseId={parseInt(databaseId)}
                    fileId={parseInt(fileId)}
                    handleCancelClicked={handleOverlayClick}
                    LayoutBoxCenteredProps={{
                        onClick: e => e.stopPropagation(),
                    }}
                    sx={{ width: "100%" }}
                />
            </LayoutFillParentCentered>
        </LayoutFullScreenOverlay>
    );
};
